((AutoplayVideo, $) => {
    
    const $dom = {};
    
    const cacheDom = () => {
      $dom.videoElements = $('.js-autoplay-video.js-has-fallback-image');
    };
    
    AutoplayVideo.init = () => {
      cacheDom();
      ensureVideoAutoplay();
    };
    
    const ensureVideoAutoplay = () => {
      $dom.videoElements.each(function(i, videoElement) {
        let promise = $(videoElement).get(0).play();
        if(promise !== undefined) {
          promise
            .then(_ => {})
            .catch(error => {
              $(videoElement).hide();
            });
        }
      })
    };
  
  })(window.AutoplayVideo = window.AutoplayVideo || {}, jQuery);